const dvlaConfig = {
  apiKey: 'aGQATvcUIO87Ob2MtHrkW1rz9VQaGKgN2Qd9zOYA',
  url: 'https://www.loophome.app/dvla/vehicle-enquiry/v1/vehicles',
};
export default dvlaConfig;
